import { render, staticRenderFns } from "./LoginModal.vue?vue&type=template&id=4785b179&scoped=true"
import script from "./LoginModal.vue?vue&type=script&lang=ts"
export * from "./LoginModal.vue?vue&type=script&lang=ts"
import style0 from "./LoginModal.vue?vue&type=style&index=0&id=4785b179&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4785b179",
  null
  
)

export default component.exports